import React, { useState } from 'react';
import {
  Container,
  Box,
  Typography,
  TextField,
  Button,
  Paper,
  Grid,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSaveInterestedClient } from './hooks/useSaveInterestedClient';
import ErrorMessage from '../components/errorMessage';
import Loading from '../components/loading';

export default function InterestedClientPage() {
  const navigate = useNavigate();
  const { save: saveInterestedClient } = useSaveInterestedClient();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [instagram, setInstagram] = useState('');
  const [answerOne, setAnswerOne] = useState('');
  const [answerTwo, setAnswerTwo] = useState('');

  const [showErrorMessage, setShowErrorMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const [isLoading, setLoading] = useState(false);

  const optionsToAnswerOne = [
    'Prontuários em papel ou informações perdidas',
    'Agenda desorganizada e falta de controle',
    'Sistemas complicados que ninguem usa',
    'Falta de histório claro dos pacientes',
    'Outro',
  ];

  const optionsToAnswerTwo = [
    'Até 100',
    'De 101 a 300',
    'De 301 a 600',
    'Acima de 600',
    'Prefiro não informar',
  ];

  const saveInterestClient = (event) => {
    event.preventDefault();

    if (!name.trim() || !email.trim() || !phoneNumber.trim()) {
      setShowErrorMessage(true);
      setErrorMessage('Por favor, preencha todos os campos.');
      return;
    }

    const input = {
      name: name,
      email: email,
      phoneNumber: phoneNumber,
      instagram: instagram,
      answerOne: answerOne,
      answerTwo: answerTwo,
    };

    setLoading(true);
    saveInterestedClient(input)
      .then((returnFromApi) => {
        setLoading(false);
        if (typeof window.fbq === 'function') {
          window.fbq('track', 'Lead');
        }
        navigate('/thank-you');
      })
      .catch((returnFromApi) => {
        setShowErrorMessage(true);
        setErrorMessage(
          'Parece que este e-mail já está cadastrado. Se precisar de ajuda, entre em contato com a gente (48)99109-4459!',
        );
        setLoading(false);
        console.error(returnFromApi);
      });
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        textAlign: 'center',
        py: { xs: 6, md: 10 },
        px: 2,
      }}
    >
      <Container maxWidth="md">
        <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
          Gerencie sua clínica odontológica com facilidade e organização
        </Typography>

        <Typography variant="h6" color="text.secondary">
          Experimente o Sigo gratuitamente e descubra como é simples cuidar da gestão enquanto você
          cuida dos seus pacientes.
        </Typography>

        <Loading isToHidden={isLoading === false} />
        {showErrorMessage && (
          <ErrorMessage
            message={errorMessage}
            show={showErrorMessage}
            setShow={setShowErrorMessage}
          />
        )}
      </Container>

      <Container maxWidth="sm">
        <Paper
          elevation={4}
          sx={{
            mt: { xs: 8, md: 12 },
            p: { xs: 3, md: 5 },
            borderRadius: 3,
          }}
        >
          <Typography variant="h5" sx={{ fontWeight: 600, mb: 4 }}>
            Comece seu teste gratuito agora
          </Typography>

          <Box component="form" onSubmit={saveInterestClient}>
            <Grid container justifyContent="center">
              <Grid container spacing={2}>
                <Grid size={12}>
                  <TextField
                    fullWidth
                    label="Nome *"
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                  />
                </Grid>
                <Grid size={12}>
                  <TextField
                    fullWidth
                    type="email"
                    label="E-mail *"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </Grid>
                <Grid size={12}>
                  <TextField
                    fullWidth
                    label="WhatsApp *"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </Grid>
                <Grid size={12}>
                  <TextField
                    fullWidth
                    label="Instagram da clínica ou do(a) Dr(a)"
                    value={instagram}
                    onChange={(e) => setInstagram(e.target.value)}
                  />
                </Grid>
                <Grid size={12}>
                  <FormControl fullWidth>
                    <InputLabel>
                      Qual a maior dificuldade na gestão da sua clínica hoje? *
                    </InputLabel>
                    <Select
                      value={answerOne}
                      onChange={(e) => setAnswerOne(e.target.value)}
                      label="Qual a maior dificuldade na gestão da sua clínica hoje? *"
                    >
                      {optionsToAnswerOne.map((option, index) => (
                        <MenuItem key={index} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
                <Grid size={12}>
                  <FormControl fullWidth>
                    <InputLabel>Quantos atendimentos sua clínica realiza por mês? *</InputLabel>
                    <Select
                      value={answerTwo}
                      onChange={(e) => setAnswerTwo(e.target.value)}
                      label="Qual a maior dificuldade na gestão da sua clínica hoje? *"
                    >
                      {optionsToAnswerTwo.map((option, index) => (
                        <MenuItem key={index} value={option}>
                          {option}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>

                <Grid size={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="success"
                    sx={{
                      py: 1.5,
                      fontSize: '1.1rem',
                      fontWeight: 'bold',
                      mt: 5,
                    }}
                  >
                    Criar meu acesso gratuito
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}
